export default __webpack_public_path__ + "static/media/your_turn.239fe5a3.mp3";